<template>
	<div class="shop-addr-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :gtype="0" />
		
		<!-- ====== 面包屑导航 ====== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn">
			<div class="breadcrumb-left">
				<span class="bc-label">{{$t('shopSuss.t1')}}</span>
				<span class="bc-item">{{$t('shopSuss.t2')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30841_3727/12.svg')"></el-image>
				<span class="bc-item bc-active">{{$t('shopSuss.t3')}}</span>
			</div>
			<div class="breadcrumb-right" @click="goback">
				<span class="bc-back-text">{{$t('shopSuss.t4')}}</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30841_3727/13.svg')"></el-image>
			</div>
		</div>

		<!-- ====== 表单卡片 ====== -->
		<div class="form-card animate__animated animate__fadeInUp">
			
			<el-image class="sussimg" :src="require('@/static/add2/9.png')"></el-image>
			<div class="t1">{{$t('shopSuss.t5')}}</div>
			<div class="t2">{{$t('shopSuss.t6')}}</div>
			<div class="t3">￥<span>{{orderMsg.totalActualPrice}}</span></div>
			
		</div>
		<!-- 保存按钮 -->
		<div class="form-footer">
			<div class="save-btn1" @click="link('/indexHome')">{{$t('shopSuss.t7')}}</div>
			<div class="save-btn" @click="link('/userPageLab/myshopOrder')">{{$t('shopSuss.t8')}}</div>
		</div>
	</div>
</template>

<script>
import {
	orderpayDetail,
} from "/src/api/api.js"
import newsPageHeader from '@/components/newsPageHeader.vue'
export default {
	name: 'ShopSuss',
	components: {
		newsPageHeader
	},
	data() {
		return {
			id:0,
			orderMsg:'',
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		this.orderpayDetailGet()
	},
	methods: {
		// 返回
		goback(){
			this.$router.go(-2);
		},
		// 订单支付详情
		async orderpayDetailGet(){
			const res = await orderpayDetail({orderPayId:this.id})
			if(res.code==200){
				this.orderMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
.shop-addr-page {
	width: 100%;
	// min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 160px;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb-bar {
	width: 1128px;
	margin: 0 auto;
	padding: 20px 0;
	padding-top: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.breadcrumb-left {
	display: flex;
	align-items: center;
}
.bc-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.bc-item {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin: 0 4px;
}
.bc-item.bc-active {
	color: #0096FF;
}
.bc-arrow {
	width: 18px;
	height: 18px;
	margin: 0 8px;
}
.breadcrumb-right {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.bc-back-text {
	font-size: 16px;
	color: #0096FF;
	font-weight: 400;
}
.bc-back-icon {
	width: 18px;
	height: 18px;
	margin-left: 6px;
}

/* ===================================================================
   表单卡片
   =================================================================== */
.form-card {
	width: 1128px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 28px 28px 40px;
	box-sizing: border-box;
	padding-top: 38px;
	.sussimg{
		width: 138px;
		margin: auto;
		display: block;
	}
	.t1{
		font-size: 16px;
		text-align: center;
		margin-top: 10px;
		font-weight: bold;
	}
	.t2{
		font-size: 14px;
		color: #A9A9A9;
		margin-top: 8px;
		text-align: center;
	}
	.t3{
		font-size: 16px;
		color: #FF4B4B;
		text-align: center;
		margin-top: 16px;
		span{
			font-size: 32px;
			font-weight: bold;
		}
	}
}

/* 标题 */
.form-title-row {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.form-title-icon {
	width: 10px;
	height: 16px;
	margin-right: 12px;
}
.form-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
}

/* 表单主体 */
.form-body {
	display: flex;
}
.form-col {
	width: 495px;
	flex-shrink: 0;
}
.form-col:first-child {
	margin-right: 32px;
}
.form-item {
	margin-bottom: 24px;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
}

.form-input-wrap {
	width: 100%;
}
::v-deep .el-select{
	width: 100%;
}
.form-input-wrap ::v-deep .el-input__inner,
.form-input-wrap ::v-deep .el-select .el-input__inner {
	height: 50px;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__suffix .el-input__suffix-inner {
	display: flex;
	align-items: center;
}
.form-input-wrap ::v-deep .el-select .el-icon-arrow-up:before {
	content: '';
}
.form-input-wrap ::v-deep .el-select .el-select__caret {
	color: #333;
	font-size: 12px;
}

/* 保存按钮 */
.form-footer {
	width: 1128px;
	margin: auto;
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
}
.save-btn1{
	width: 184px;
	height: 50px;
	background: #fff;
	border-radius: 10px;
	color: #0096FF;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
	border: 1px solid #0096FF;
	transition: background 0.3s;
	margin-right: 20px;
}
.save-btn1:hover {
	color: #33ABFF;
	border: 1px solid #33ABFF;
}
.save-btn {
	width: 184px;
	height: 50px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
	transition: background 0.3s;
}
.save-btn:hover {
	background: #33ABFF;
}
</style>
